import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'pcg-steps',
    templateUrl: './steps.component.html',
    styleUrls: ['./steps.component.scss'],
    standalone: false
})
export class StepsComponent implements OnInit {
	// Attributes that can be passed in
	@Input() currentStep: number;
	@Input() stepCount: number;
	@Input() completedSteps: number;

	// Allow users to set a clickStep event
	@Output() clickStep = new EventEmitter();

	// This is an array of step numbers: [ 1 ... stepCount ]
	steps: number[];
	// Whether or not the click event was overwritten
	hasClickEvent = false;

	ngOnInit() {
		// Create an array with step numbers, which will be looped through in the template
		this.steps = Array.from(new Array(this.stepCount), (val, i) => i + 1);
		// Default completedSteps to currentStep if none given
		this.completedSteps = this.completedSteps || this.currentStep;
		// Set hasClickEvent. Template will do cursor: pointer if so.
		this.hasClickEvent = this.clickStep.observers.length > 0;
	}

	// On click of a step
	onClick(i: number) {
		this.clickStep.emit(i);
	}
}
